<template>
    <div class="data-overview-page-wrapper">
        <OptOverviewBar @langSelect="langSelect" @channelSelect="channelSelect" @timeChange="timeChange" />
        <OverViewPanel class="mt-b" :optData="optData" />
        <DataTrendPanel class="mt-b" :optData="optData" />
        <RobotDataDetail :optData="optData" />
        <LabourDataDetail :optData="optData" />
    </div>
</template>

<script>
import OptOverviewBar from "./components/OptOverviewBar";
import DataTrendPanel from "./components/DataTrendPanel";
import OverViewPanel from "./components/OverViewPanel";
import RobotDataDetail from "./components/RobotDataDetail";
import LabourDataDetail from "./components/LabourDataDetail";

export default {
    name: "DataOverviewPage",
    components: {
        OptOverviewBar,
        DataTrendPanel,
        OverViewPanel,
        RobotDataDetail,
        LabourDataDetail
    },
    data() {
        return {
            optData: {
                lang: "",
                channel: "",
                startTime: "",
                endTime: ""
            }
        };
    },
    methods: {
        langSelect(data) {
            this.optData.lang = data.value;
        },
        channelSelect(data) {
            this.optData.channel = data.value;
        },
        timeChange(times) {
            this.optData.startTime = this.zhiji.transDateSparetor(times[0], "/", "-");
            this.optData.endTime = this.zhiji.transDateSparetor(times[1], "/", "-");
        }
    }
};
</script>

<style lang="scss" scope>
.data-overview-page-wrapper {
    width: 100%;
    height: 100%;
    padding: 4px 16px 24px 16px;
    box-sizing: border-box;
    background: #f2f7fb;
    overflow-y: auto;
    .mt-b {
        margin-bottom: 16px;
    }
}
</style>
